import { IconAlert } from "@amzn/stencil-react-components/icons";
import { withTooltip } from "@amzn/stencil-react-components/tooltip";

export default withTooltip()(IconAlert);
